import { AdStatus } from '@/types';

export enum ErrorCodesEnum {
  ValidationError = 'VALIDATION_ERROR',
  UserBannedError = 'USER_BANNED_ERROR',
}

export type ErrorExtension = {
  code: ErrorCodesEnum;
};

export type MutationError = {
  message: string;
  code?: string;
  path?: string[];
  extensions?: ErrorExtension;
};

export type MutationResponse<Entity> = {
  entity: Entity;
  errors: MutationError[];
};

export enum AdKind {
  Bumped = 'BUMPED',
  Premium = 'PREMIUM',
  Vipped = 'VIPPED',
}

export type AssetUrl = {
  id: string;
  url: string;
};

export type Shop = {
  id: string;
  logo: AssetUrl;
  name: string;
  uri: string;
  workingDays: string;
  workingHours: string;
  description: string;
};

export type Ad = {
  id: string;
  kinds: AdKind[];
  photo: AssetUrl;
  isBookmarked: boolean;
  price: number | null;
  region: string;
  path: string;
  shop: Shop | null;
  title: string;
  updatedAt: string;
  legacyResourceId: number;
  status: AdStatus;
};

export type CreateCallResponse = {
  createCall: MutationResponse<string[]>;
};

export type CreateReportResponse = {
  createReport: MutationResponse<boolean>;
};

export enum PlatformSource {
  Mobile = 'MOBILE',
  App = 'APP',
  Desktop = 'DESKTOP',
}
